<section class="centered-with-padding py-7">
  @if (data.title; as title) {
    <div class="mb-4 font-title text-[30px] leading-[28px] tracking-[-0.6px]">{{ title }}</div>
  }
  <div class="flex flex-col gap-[14px]">
    @for (faq of faqs(); track $index) {
      <a
        [routerLink]="faq.url"
        class="drop-shadow-custom flex items-center justify-between gap-x-4 rounded-xl bg-gray-light py-[18px] pl-6 pr-2 desk:pr-[18px]">
        <span class="font-bold">{{ faq.question }}</span>
        <div class="min-w-[14px]">
          <app-svg [height]="14" [width]="7" src="assets/icons/caret-right.svg" />
        </div>
      </a>
    }
  </div>
</section>
